import React, { useEffect, useState } from "react";
import Switch from "react-switch";

import Text from "../../Text";
import Spacer from "../../Spacer";
import style from "./style.module.css";

export default function Toggle(props) {
    const { labelLeft = "", labelRight = "", input: { onChange = () => { }, value = false }, label = false } = props;
    const [checked, setChecked] = useState(value || false);

    const handleToggle = (val) => {
        setChecked(val);
    };

    useEffect(() => {
        onChange(checked);
    }, [checked]);

    useEffect(() => {
        setChecked(value);
    }, [value]);

    return (
        <div>
            {label !== false &&
                <>
                    <div className={`${style.controlLabel}`}>
                        <span dangerouslySetInnerHTML={{ __html: label }}></span>
                    </div>
                    <Spacer size={8} />
                </>
            }
            <div className={style.switchWrapper}>
                <Text className={checked ? "" : style.switchLabel}>{labelLeft}</Text>
                <Switch
                    onChange={handleToggle}
                    checked={checked}
                    offColor="#B0B7C0"
                    onColor="#B0B7C0"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    handleDiameter={20}
                    height={14}
                    width={32}
                    uncheckedHandleIcon={
                        <div className={style.uncheckedIcon} />
                    }
                    checkedHandleIcon={
                        <div className={style.checkedIcon} />
                    }
                />
                <Text className={checked ? style.switchLabel : ""}>{labelRight}</Text>
            </div>
        </div>
    );
}